import { useTranslation } from 'react-i18next';
import { bankNameSchema, type BankName } from '@hero/schema';
import { SelectAuto, type SelectAutoOption } from '../../../app/Select';

const BANK_KEYS = bankNameSchema.options;

export interface BankSelectorProps {
  value?: BankName;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
}

export function BankSelector(props: BankSelectorProps) {
  const { t } = useTranslation(['m-organization', 'm-payment']);
  const { value, ...rest } = props;

  const bankOptions: SelectAutoOption[] = BANK_KEYS.map(key => ({
    value: key,
    label: t(`m-payment:banks.${key}.title`),
  }));

  return (
    <SelectAuto
      label={rest.label ?? t('m-organization:form.bank_name.title')}
      placeholder={rest.placeholder ?? t('m-organization:form.bank_name.placeholder')}
      value={value}
      options={bankOptions}
      {...rest}
    />
  );
}
